import PropTypes from "prop-types"

import "./upsell.scss"

export default function Upsell({
  extraClass,
  proSubscriptionUrl,
  proPlusSubscriptionUrl,
  tier,
}) {
  if (["pro", "legacy_pro"].includes(tier)) {
    return ""
  }

  let copy = "Get Pro to get 20 Applets"
  let link = proSubscriptionUrl
  let object_id = "pro_link"

  if (tier === "intermediate_pro") {
    copy = "Get Pro+ for unlimited Applets"
    link = proPlusSubscriptionUrl
    object_id = "pro_plus_link"
  }

  return (
    <a
      href={link}
      data-track-ifttt-next-event="click"
      data-track-data={JSON.stringify({
        object_id,
        object_type: "pro_upsell",
        location_type: "my_applets",
      })}
      className="link-standalone"
      styleName={`pro-upsell ${extraClass}`}
    >
      {copy}
    </a>
  )
}

Upsell.propTypes = {
  extraClass: PropTypes.string,
  proPlusSubscriptionUrl: PropTypes.string.isRequired,
  proSubscriptionUrl: PropTypes.string.isRequired,
  tier: PropTypes.string.isRequired,
}

Upsell.defaultProps = {
  extraClass: "",
}
